import { render, staticRenderFns } from "./ButtonPrimary.vue?vue&type=template&id=0ecb2e14&"
import script from "./ButtonPrimary.vue?vue&type=script&lang=js&"
export * from "./ButtonPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports